// extracted by mini-css-extract-plugin
export default {"Checkbox":"Ve8Ye1ML","CheckboxPlaceholder":"jsNaFo18","SharedCheckboxPlaceholder":"uU7OPX6c","SharedCheckbox":"aD5lEQqp","Check":"qcXIsHzk"};